import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import { DynamicGenericArticleFooter, DynamicMorningStudioArticleFooter } from "./dynamics";

const CommonArticleFooterStyle = () => css`
  max-inline-size: 1208px;
  margin-inline: auto;

  /* Opt the whole footer block out of Chrome scroll anchoring — the footer
     mounts via dynamic import + a lazy query, and can enter the viewport
     after the user has already scrolled to it; without this, the mount is
     treated as a layout shift attributed to this container. */
  overflow-anchor: none;

  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 80px;
  }
`;

export const StyledGenericArticleFooter = styled(DynamicGenericArticleFooter)`
  ${CommonArticleFooterStyle}

  ${theme.breakpoints.only("mobile")} {
    margin-block-start: 38px;
  }
`;

export const StyledMorningStudioArticleFooter = styled(DynamicMorningStudioArticleFooter)`
  ${CommonArticleFooterStyle}
`;
